var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from "@emotion/css";
import ImageElement from "./ImageElement";
import EmbedElement from "./EmbedElement";
import VideoElement from "./VideoElement";
import TableElement from "./TableElement";
import HorizontalElement from "./HorizontalElement";
import UnsplashElement from "./UnsplashElement";
var CustomElement = function (props) {
    var attributes = props.attributes, children = props.children, element = props.element;
    var style = { textAlign: element.align };
    switch (element.type) {
        case "quote":
            return (_jsx("q", __assign({ className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            border-left: 2px solid #ddd;\n            margin-left: 0;\n            margin-right: 0;\n            padding-left: 10px;\n            color: #aaa;\n            font-style: italic;\n            display: block;\n          "], ["\n            border-left: 2px solid #ddd;\n            margin-left: 0;\n            margin-right: 0;\n            padding-left: 10px;\n            color: #aaa;\n            font-style: italic;\n            display: block;\n          "]))), style: style }, attributes, element, { children: children })));
        case "code":
            return (_jsx("code", __assign({ className: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            background-color: #eee;\n            padding: 3px;\n            display: block;\n          "], ["\n            background-color: #eee;\n            padding: 3px;\n            display: block;\n          "]))), style: style }, attributes, element, { children: children })));
        case "link":
            return (_jsx("a", __assign({ style: style }, attributes, { href: element.url, id: element.id }, { children: children })));
        case "image":
            return _jsx(ImageElement, __assign({}, __assign(__assign({}, props), { element: element })));
        case "horizontal":
            return _jsx(HorizontalElement, __assign({}, __assign(__assign({}, props), { element: element })));
        case "unsplash":
            console.log("element", element);
            return _jsx(UnsplashElement, __assign({}, __assign(__assign({}, props), { element: element })));
        case "anchor":
            return (_jsx("p", __assign({}, attributes, element, { children: children })));
        case "video":
            return _jsx(VideoElement, __assign({}, __assign(__assign({}, props), { element: element })));
        case "embed":
            setTimeout(function () {
                instgrm.Embeds.process();
            }, 100);
            return _jsx(EmbedElement, __assign({}, __assign(__assign({}, props), { element: element })));
        case "sub-title":
            return (_jsx("h1", __assign({ style: style }, attributes, element, { children: children })));
        case "heading-one":
            return (_jsx("h1", __assign({ style: style }, attributes, element, { children: children })));
        case "heading-two":
            return (_jsx("h2", __assign({ style: style }, attributes, element, { children: children })));
        case "list-item":
            return (_jsx("li", __assign({ style: style }, attributes, element, { children: children })));
        case "bulleted-list":
            return (_jsx("ul", __assign({ style: style }, attributes, element, { children: children })));
        case "numbered-list":
            return (_jsx("ol", __assign({ style: style }, attributes, element, { children: children })));
        case "table":
            return _jsx(TableElement, __assign({}, __assign(__assign({}, props), { element: element })));
        case "table-row":
            return _jsx("tr", __assign({}, attributes, { children: children }));
        case "table-cell":
            return _jsx("td", __assign({}, attributes, { children: children }));
        default:
            return (_jsx("p", __assign({ className: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            margin: 0;\n            padding: 0;\n          "], ["\n            margin: 0;\n            padding: 0;\n          "]))), style: style }, attributes, element, { children: children })));
    }
};
export default CustomElement;
var templateObject_1, templateObject_2, templateObject_3;
